export class Telefone {
    static create() {
        return {
            tipo: null,
            contato: null,
            numero: null
        };
    }
}
